@if (activeProject(); as project) {
  <div class="project-selector">
    <p class="project-selector__name">
      <span class="project-selector__label">{{ 'layout.top.projectActive' | translate }}:</span>
      {{ project.name }}
    </p>
    <button sci-button type="button" class="project-selector__change" (click)="openSelector()">
      {{ 'layout.top.changeProject' | translate }}
    </button>
  </div>
}
